import { useNavigate, useParams } from "react-router-dom";
import { RunStepsModal } from "../components/run-steps/run-steps-modal";

export default function RunStepsPage() {
  const { responseId } = useParams();
  const navigate = useNavigate();

  return (
    <RunStepsModal
      isOpen={true}
      onClose={() => navigate(-1)}
      responseId={responseId || null}
    />
  );
}
